import React, { useState } from 'react';
import HttpService from '../../service/HttpService';

const PrintReportButton = ({ sessionId, sessionTitle, className = '', onError }) => {
    const { axiosInstance } = HttpService();
    const [loading, setLoading] = useState(false);

    const handlePrint = async () => {
        let fileURL = null;
        setLoading(true);
        try {
            const response = await axiosInstance.get(`/report/generate/${sessionId}`, {
                responseType: 'arraybuffer',
            });

            const blob = new Blob([response.data], { type: 'application/pdf' });
            fileURL = window.URL.createObjectURL(blob);

            const newTab = window.open(fileURL, '_blank');
            if (!newTab || newTab.closed || typeof newTab.closed === 'undefined') {
                // Fallback to download
                const link = document.createElement('a');
                link.href = fileURL;
                const filename = sessionTitle
                    ? `Report-${sessionTitle.replace(/\s+/g, '_')}.pdf`
                    : `Report-${sessionId}.pdf`;
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(fileURL);
                fileURL = null;
            }
        } catch (error) {
            if (onError) {
                const errorMessage = error.response?.data?.userMessage || error.message || 'Failed to download or open PDF. Please try again.';
                onError(errorMessage);
            }
            if (fileURL) window.URL.revokeObjectURL(fileURL);
        } finally {
            setLoading(false);
        }
    };

    return (
        <button
            onClick={handlePrint}
            className={`bg-blue-500 hover:bg-blue-700 text-white text-xs font-bold py-1 px-2 rounded focus:outline-none focus:shadow-outline ${className}`}
            title="Print Report"
            disabled={loading}
        >
            <i className="fas fa-print mr-1"></i>
            {loading ? 'Printing...' : 'Print'}
        </button>
    );
};

export default PrintReportButton;